import { IConfigsType } from '../../types'

// why: gated under the customized-reports brand to mirror the access policy
// of Weekly Labor Tracker — Gerald's PRD requires "Access restricted to same
// role-gate as existing Labor by Store page" (= weekly_labor_tracker on FW).
const fwWingstopLaborTrend: IConfigsType = {
  'fw_wingstop-customized-reports-7375b6fb': {
    '/:brand/labor_trend': {
      feV2: {
        type: 'FE V2',
        configPath: 'fw_wingstop/labor_trend',
        height: '100vh',
      },
    },
  },
}

export default fwWingstopLaborTrend
